export interface ReplayCribSnapshot {
  guid?: string;
  kraalGuid?: string;
  kraalId?: string | number;
  score?: string | number | null;
  call?: string | number | null;
  status?: string | null;
  ration?: string | null;
  actualFed?: string | number | null;
  animalCount?: string | number | null;
  sequence?: string | number | null;
}

const fields: { key: keyof ReplayCribSnapshot; label: string; unit?: string }[] = [
  { key: "score", label: "score" },
  { key: "call", label: "call" },
  { key: "status", label: "status" },
  { key: "ration", label: "ration" },
  { key: "actualFed", label: "fed", unit: " kg" },
  { key: "animalCount", label: "animals" },
  { key: "sequence", label: "sequence" },
];

function identity(item: ReplayCribSnapshot) {
  return item.kraalGuid || String(item.kraalId ?? item.guid);
}

function display(value: unknown, unit = "") {
  return value === null || value === undefined || value === "" ? "—" : `${value}${unit}`;
}

// Compare by kraal rather than row order or the ID of an individual reading.
export function summarizeReplayChanges(previous: ReplayCribSnapshot[], current: ReplayCribSnapshot[]): string[] {
  const remaining = new Map(previous.map((item) => [identity(item), item]));
  const changes: string[] = [];
  for (const item of current) {
    const key = identity(item);
    const before = remaining.get(key);
    const label = `Kraal ${item.kraalId ?? key}`;
    remaining.delete(key);
    if (!before) {
      changes.push(`${label}: added`);
      continue;
    }
    const details = fields
      .filter(({ key }) => display(before[key]) !== display(item[key]))
      .map(({ key, label, unit }) => `${label} ${display(before[key], unit)} → ${display(item[key], unit)}`);
    if (details.length) changes.push(`${label}: ${details.join("; ")}`);
  }
  for (const item of remaining.values()) changes.push(`Kraal ${item.kraalId ?? identity(item)}: removed`);
  return changes;
}
